import { Badge, Typography } from '@smartgift/frontend-toolkit';
import styled, { css } from 'styled-components';

const IconArea = styled.div`
  display: flex;
  justify-content: center;
`;

const ReviewHead = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: space-between;
  margin-bottom: 16px;
`;

const ReviewHeadTitle = styled.div`
  display: flex;
  flex-direction: column;
`;

const DownloadArea = styled.div`
  align-items: center;
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-top: 16px;
`;

const HeaderSteps = styled.div`
  align-items: center;
  display: flex;
  gap: 24px;
  justify-content: center;
  margin-bottom: 16px;
`;

const InfoText = styled.div`
  align-items: center;
  color: var(--color-fg-weaker);
  display: flex;
  font-size: 12px;
  gap: 4px;
  justify-content: center;
  margin-top: 16px;
  text-align: center;
`;

const FormContent = styled.div`
  overflow: auto;
  width: 100%;
`;

const TitleSpan = styled.span`
  font-weight: 400;
`;

const ErrorText = styled.span`
  color: var(--color-error-default);
`;

const TitleHeader = styled.div`
  margin-bottom: 16px;
`;

const ResultItem = styled.div`
  display: flex;
  flex-direction: row;
`;

const InfoCard = styled.div`
  background-color: var(--color-blue-50);
  border: 1px solid var(--color-blue-100);
  border-radius: var(--size-border-radius-md);
  display: flex;
  flex-direction: row;
  font-size: 14px;
  gap: 8px;
  padding: 16px;
  width: 324px;
`;

const TagList = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
`;

const TagBadge = styled(Badge)`
  position: relative;

  ${({ hasAutomation }) => {
    return (
      hasAutomation &&
      css`
        ::before {
          background: var(--color-info-default);
          border-radius: 100%;
          content: '';
          height: 10px;
          left: -2px;
          position: absolute;
          top: -2px;
          width: 10px;
        }
      `
    );
  }}
`;

const ResultTitle = styled(Typography)`
  display: flex;
  padding-top: 6px;
  width: 120px;
`;

const ResultDescription = styled.div`
  color: var(--color-fg-weaker);
  flex: 1;
  font-size: 14px;

  b {
    color: var(--color-fg-default);
    font-size: 18px;
  }
`;

const ResultBody = styled.div`
  align-items: flex-start;
  display: flex;
  flex: 1;
  flex-direction: row;
  gap: 24px;
  justify-content: space-between;
  padding: 8px 0;
`;

const Wrapper = styled.div``;

const SuccessIconWrapper = styled.div`
  align-items: center;
  background: var(--color-bg-body);
  border: 1px solid var(--color-green-500);
  border-radius: var(--size-border-radius-circle);
  display: flex;
  height: 40px;
  justify-content: center;
  width: 40px;
`;

const IconWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`;

const UploadEmailReviewImport = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

export {
  DownloadArea,
  ErrorText,
  FormContent,
  HeaderSteps,
  IconArea,
  IconWrapper,
  InfoCard,
  InfoText,
  ResultBody,
  ResultDescription,
  ResultItem,
  ResultTitle,
  ReviewHead,
  ReviewHeadTitle,
  SuccessIconWrapper,
  TagBadge,
  TagList,
  TitleHeader,
  TitleSpan,
  UploadEmailReviewImport,
  Wrapper
};
